export const container = `w-full flex justify-between items-center mb-2`;
export const title = `text-xs font-normal text-base-black`;
export const icon = `w-4 h-4 ml-3 cursor-pointer`;
